import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[license-func-host]',
})
export class LicenseFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}